<template>


  <div>

    <div class="float-label" v-if="!data.select">
      <input v-if="data.type != 'textarea'" v-model="inputed" :class="{error: !!error, notinteracted:!interacted}" :id="data.id" :type="data.type"
             :placeholder="data.placeholder" @click="interacted=true"/>
      <textarea v-else rows="10" v-model="inputed" :class="{error: !!error, notinteracted:!interacted, 'uk-textarea': true}" :id="data.id" :type="data.type"
           :placeholder="data.placeholder" @click="interacted=true"/>
      <label :for="data.id">{{ data.label }}</label>
      <div class="error-warning" v-if="error">{{ error }}</div>
    </div>

    <div class="float-label" v-if="data.select">
      <select v-model="inputed" :class="{error: data.error, notinteracted:!interacted}" @click="interacted=true">
        <option selected disabled>{{ data.placeholder }}</option>
        <option v-for="(opt, i) in data.options" :key="i" :value="opt.value">{{ opt.display }}</option>
      </select>
      <label :for="data.id">{{ data.label }}</label>
    </div>

  </div>

</template>

<script>

  import {debounce} from "../../utils/throttle.js";
  import validators from "../../utils/validate.js";
  import validate from 'validate.js';

	export default {
		name: "FloatFieldInput",
		props: ["data"],
		data: function () {
			return {
				interacted: false,
				inputed: null,
        error: null,
			}
		},
		watch: {
			inputed: function () {
				this.$emit("inputevent", this.inputed);
				if (this.data.constraints) {
					const error = validate({inputed: this.inputed}, {inputed: this.data.constraints})
					if (error) {
						// this.error = this.inputed + ' : ' + error.inputed.toString().replace("Inputed", "");
                        this.error = error.inputed.toString().replace("Inputed", "").toUpperCase();
					} else {
						this.error = null;
					}
				}
				if (this.error != null) {
				    this.$emit("fieldError", this.error)
                }
			}

        }
	}
</script>

<style lang="less" scoped>

/*textarea*/
/*{*/
  /*width:100%;*/
  /*border-radius: 20px;*/
  /*margin: 5px;*/
  /*cursor: text;*/
/*}*/
.textwrapper
{
  border:1px solid #999999;
  margin:5px 0;
  padding:3px;
    color: #10315E;
}

.float-label {
  display: block;
  position: relative;
}
.float-label label,
.float-label > span {
  position: absolute;
  left: 20px;
  top: 0.4em;
  cursor: text;
  font-size: 75%;
  opacity: 1;
  transition: all .2s;
}
.float-label select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.float-label input,
.float-label select,
.float-label textarea{
  font-size: 1.2em;
  padding-top: 25px;
  padding-left: 1em;
  margin-bottom: 8px;
  border: 0;
  border-radius: 0;
  border: 2px solid rgba(91, 57, 143, 0.2);
  background-color: transparent;
  border-radius: 5px;
  margin-right: 1.2em;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  top: .25em;
}
.float-label input::placeholder,
.float-label select::placeholder {
  opacity: .6;
  transition: all .2s;
}
.float-label input:placeholder-shown:not(:focus)::placeholder,
.float-label select:placeholder-shown:not(:focus)::placeholder {
  opacity: 0;
}
.float-label input:placeholder-shown:not(:focus) + *,
.float-label select:placeholder-shown:not(:focus) + * {
  font-size: 110%;
  opacity: .9;
}
.float-label input:focus,
.float-label select:focus {
  outline: none;
  border-color: rgba(91, 57, 143, 0.7);
  padding-bottom: .3em;
}
.float-label input:not(:placeholder-shown),
.float-label select:not(:placeholder-shown) {
  padding-bottom: .3em;
}
.float-label input.error,
.float-label select.error {
  border-color: rgba(211, 75, 71, 0.7);
  -webkit-box-shadow: 0 6px 3px -3px rgba(211, 75, 71, 0.2);
  -moz-box-shadow: 0 6px 3px -3px rgba(211, 75, 71, 0.2);
  box-shadow: 0 6px 3px -3px rgba(211, 75, 71, 0.2);
}
.float-label select {
  padding-right: 1em;
  background: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right 0.5em bottom 50%;
  background-size: 8px 10px;
  padding-bottom: .2em;
}
.float-label select.notinteracted {
  color: rgba(16, 49, 94, 0.5);
}
.error-warning {
  font-size: .8em;
  color: #D34B47;
  margin-top: -6px;
  margin-bottom: 4px;
}
input,
select {
  width: 100%;
  color: #10315E;
}

</style>
